// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rZnrl","importantInfo":"styles_importantInfo__14giM"};